<mat-card>
  <form #passwordForm="ngForm" novalidate autocomplete="off" (ngSubmit)="changePassword()">
    <img src="assets/images/aspen-logo.svg" alt="" class="brand-logo" />



    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-icon matPrefix><img src="assets/images/icon-password.svg" /></mat-icon>
        <input #passwordField="ngModel" name="password" [(ngModel)]="password" autocomplete="off" matInput
          type="password" placeholder="Password" minlength="7" required
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-+_!@#$%^&*.,?])(^\S*$)" />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-icon matPrefix><img src="assets/images/icon-password.svg" /></mat-icon>
        <input name="passwordConfirm" [(ngModel)]="passwordConfirm" autocomplete="off" matInput type="password"
          placeholder="Confirm Password" minlength="7" required
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-+_!@#$%^&*.,?])(^\S*$)" />
      </mat-form-field>
    </div>

    <button *ngIf="!passwordChanged" mat-raised-button color="accent" (click)="changePassword()"
      [disabled]="passwordForm.invalid || password != passwordConfirm">CHANGE</button>
    <button *ngIf="!passwordChanged" mat-raised-button color="primary" [routerLink]="['/']">CANCEL</button>
    <button *ngIf="passwordChanged" mat-raised-button color="primary" [routerLink]="['/']">CLOSE</button>

    <div class="alert alert-success" *ngIf="passwordChanged">Password reset successful</div>
    <div class="alert alert-warning" *ngIf="password != passwordConfirm">Passwords do not match</div>
    <div class="alert alert-warning" *ngIf="passwordFailed">Password change failed</div>
    <div class="alert alert-warning" *ngIf="passwordField?.errors?.minlength">Minimum password length is
      {{passwordField?.errors?.minlength?.requiredLength}}</div>
    <div class="alert alert-warning" *ngIf="passwordField?.errors?.pattern">Must contain at least one of each of the
      following: Uppercase
      letter (A-Z), Lowercase letter (a-z), Digit (0-9) and Special Character (?=.*[-+_!@#$%^&*.,?), No Spaces allowed
    </div>

  </form>
</mat-card>
